import { UsersService } from '../../../../../../api/services';
import { Paginated, User } from '../../../../../../types';

export function findUsers({ queryKey }: any) {
  const [, query] = queryKey;
  return UsersService.find({ query: { $limit: 100, ...query } }).then(
    (res: Paginated<User>) => res.data,
  );
}
